export default function Partners() {
  return null;
}
